module.exports = __webpack_public_path__ + "static/media/benefits8.25bdc84a.png";